import { createContext } from 'react';

const MegaMenuContext = createContext();

export default MegaMenuContext;
